import { createMandatoryContext } from '@change-corgi/core-react/context';

import type { UseBannerStateReturn } from './hook';

export const {
	Context: StarterDashboardBannerStateContext,
	Provider: StarterDashboardBannerStateContextProvider,
	useContext: useStarterDashboardBannerState,
} = createMandatoryContext<UseBannerStateReturn | undefined, UseBannerStateReturn>(undefined, {
	name: 'BannerStateContext',
	processProviderProps: ({ data, actions }) => ({ data, actions }),
});

export type StarterDashboardPageBannerState = ReturnType<typeof useStarterDashboardBannerState>;
